import type { IterableElement } from 'type-fest'

import { Ticker } from './ticker'

export const CRYPTO_COIN_TICKERS = [
  Ticker.BNB,
  Ticker.ETH,
  Ticker.BTC,
  Ticker.TRX,
  Ticker.POL,
  Ticker.SOL,
  Ticker.LTC
] as const

export type CryptoCoinTicker = IterableElement<typeof CRYPTO_COIN_TICKERS>
